import React, { useState, useEffect, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import { connect } from 'react-redux';
import Utility from '../../../Utility/Utility';
import { loaderStateTrue, loaderStateFalse, roleWisePermission } from '../../../Actions/AllAction';
import { setToken, setUserCredentials, logOutApp, setVersionList } from '../Actions/LoginAction';
import { Modal } from 'react-bootstrap';
import CommonLogin from '../Components/CommonLogin';
import * as LoginController from '../Controller/LoginController';
import '../Assets/css/logindoc.scss';
import '../Assets/css/tabs-login.scss';
import '../Assets/css/loginresponsivedoc.scss';
import LoginUtility from '../Utility/LoginUtility'
import PropTypes from 'prop-types';
import ModalGlobal from '../../../Utility/Components/ModalGlobal';
import ConfirmationAlert from '../../../Utility/Components/ConfirmationAlert';
import { version } from 'react-dom/cjs/react-dom.production.min';
import logger from '../../../logger';
import { withNamespaces } from 'react-i18next';
import i18n from '../../../i18n';
import { getRedirectInfo, createRedirectUrl, clearRedirectInfo } from "../../../Utility/helpers/authRedirect";
import { useParams } from 'react-router-dom';
import Cookies from 'js-cookie';
import SmsVerification from '../Components/SmsVerification';

const LoginPage = (props) => {
	const channel = new BroadcastChannel('pms-booking-engine-channel');
	const [email, setemail] = useState(Cookies.get('rememberMe') == 'true' ? Cookies.get('email') : "")
	const [password, setpassword] = useState(Cookies.get('rememberMe') == 'true' ? Cookies.get('password') : "")
	const [updated_password, setupdated_password] = useState("")
	const [updated_confirm_password, setupdated_confirm_password] = useState("")
	const [isRemember, setIsRemember] = useState(Cookies.get('rememberMe') == 'true' ? true : false)
	const [smsVerificationModalContentFlag, setSmsVerificationModalContentFlag] = useState(false);
	const { type } = useParams();

	// Phone OTP Login states
	const [phone, setPhone] = useState("")
	const [otp, setOtp] = useState("")
	const [otpSent, setOtpSent] = useState(false)
	const [sessionToken, setSessionToken] = useState("")
	const [selectedActiveTab, setSelectedActiveTab] = useState("")

	const [state, setState] = useState({
		emailError: "",
		passwordError: "",
		phoneError: "",
		otpError: "",
		updated_passwordError: "",
		updated_comfirm_passwordError: "",
		passwordLock: false,
		confirmPasswordLock: false,
		passtype: "password",
		confirmPasstype: "password",
		loginCredentials: {},
		//modal
		modalShow: false,
		updatedPasswordSession: "",
		challangeName: "",
		userName: "",
		// Focus
		emailFocus: false,
		passwordFocus: false,
		// Language change
		langaugeConfirmModal: false,
		selectedLangauge: "",
		changePasswordLock: false,
		changePasstype: "password",
		changeConpasstype: "password",
		changeConpasswordLock: false

	})

	const [emailFromParam, setEmailFromParam] = useState("")
	const [paymentIdFromParam, setPaymentIdFromParam] = useState("")
	const [bookingIdFromParam, setBookingIdFromParam] = useState("")


	const [smsVerficationPopupStatus, setSmsVerficationPopupStatus] = useState("")
	const [challangeName, setChallangeName] = useState("")

	//Check multi language
	useEffect(() => {
		//first time check token already exists then redirect to this path
		if (props.token && props.token != "" && props.token != null) {
			const previousUrl = sessionStorage.getItem('previousUrl');
			if (previousUrl && previousUrl !== `/${localStorage.getItem('i18nextLng')}/login`) {
				history.push(previousUrl);
			}


		} else {
			let redirect_to = type && type != '' ? type : 'login';

			if (redirect_to == "hotel-details") {
				props.history.push(`/${localStorage.getItem('i18nextLng')}/login/${redirect_to}`);
			} else if (redirect_to == "tour-details") {
				props.history.push(`/${localStorage.getItem('i18nextLng')}/login/${redirect_to}`);
			} else if (redirect_to == "booking-history") {
				props.history.push(`/${localStorage.getItem('i18nextLng')}/login/${redirect_to}`);
			} else if (redirect_to == "customerGroupexits") {
				props.history.push(`/${localStorage.getItem('i18nextLng')}/login/${redirect_to}`);
			} else if (redirect_to == "customerexits") {
				props.history.push(`/${localStorage.getItem('i18nextLng')}/login/${redirect_to}`);
			}
			else {
				props.history.push(`/${localStorage.getItem('i18nextLng')}/login`);
			}
			props.loaderStateFalse();
		}



	}, [])

	useEffect(() => {

	}, [emailFromParam, paymentIdFromParam, bookingIdFromParam])

	const { loaderStateTrue, loaderStateFalse, history, logOutApp, setToken, setUserCredentials, roleWisePermission } = props;


	//focus event email and password
	const handleonFocus = (event) => {
		if (event.target.name == "email") {
			setState(prev => ({
				...prev,
				emailFocus: true
			}))
		}

		if (event.target.name == "password") {
			setState(prev => ({
				...prev,
				passwordFocus: true
			}))
		}

	}

	//blur event
	const handleonBlur = (event) => {
		setState(prev => ({
			...prev,
			emailFocus: false,
			passwordFocus: false
		}))
	}

	//handlechange event
	const handleChange = (event) => {
		if (event.target.name == "email") {
			if (event.target.value == "") {
				setState(prev => ({
					...prev,
					emailError: `${props.t('emailError')}`
				}))
				setemail(event.target.value)
			} else {
				setState(prev => ({
					...prev,
					emailError: "",
				}))
				setemail(event.target.value)
			}
		}
		// Phone number field validation
		if (event.target.name == "phone") {
			const value = event.target.value;
			setPhone(value);

			// Validate phone number
			if (value === "") {
				setState(prev => ({
					...prev,
					phoneError: "Phone number is required"
				}));
			} else if (!/^\d{10}$/.test(value)) {
				setState(prev => ({
					...prev,
					phoneError: "Enter valid 10 digit phone number"
				}));
			} else {
				setState(prev => ({
					...prev,
					phoneError: ""
				}));
			}
		}

		// OTP field validation
		if (event.target.name == "otp") {
			const value = event.target.value;
			setOtp(value);

			// Validate OTP
			if (value === "") {
				setState(prev => ({
					...prev,
					otpError: "OTP is required"
				}));
			} else if (!/^\d{6}$/.test(value)) {
				setState(prev => ({
					...prev,
					otpError: "Enter valid 6 digit OTP"
				}));
			} else {
				setState(prev => ({
					...prev,
					otpError: ""
				}));
			}
		}
		if (event.target.name == "password") {
			if (event.target.value == "") {
				setState(prev => ({
					...prev,
					passwordError: `${props.t('passwordError')}`
				}))
				setpassword(event.target.value)

			} else {
				setState(prev => ({
					...prev,
					passwordError: "",
				}))
				setpassword(event.target.value)
			}

		}
		if (event.target.name == "updated_password") {
			setState(prev => ({
				...prev,
				updated_passwordError: ""
			}))

			setupdated_password(event.target.value)
		}
		if (event.target.name == "updated_confirm_password") {
			setState(prev => ({
				...prev,
				updated_comfirm_passwordError: ""
			}))
			setupdated_confirm_password(event.target.value)
		}
	}

	//validation before login api call
	const validation = () => {
		let valid = true;
		if (email == "") {
			valid = false;
			setState(prev => ({
				...prev,
				emailError: `${props.t('emailError')}`
			}))
		} else {
			var expr = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
			if (!expr.test(email)) {
				setState(prev => ({
					...prev,
					emailError: `${props.t('validEmail')}`
				}))
				valid = false;
			} else {
				setState({
					emailError: ""
				})
			}
		}

		if (password.trim() === "") {
			valid = false;
			setState(prev => ({
				...prev,
				passwordError: "Please enter password"
			}));
		} else if (password.length < 6) {
			valid = false;
			setState(prev => ({
				...prev,
				passwordError: "Password must be at least 6 characters."
			}));
		} else {
			setState(prev => ({
				...prev,
				passwordError: ""
			}));
		}
		return valid;
	}

	//forgotPassword redirect fn
	const forgotPassword = () => {
		props.history.push(`/${localStorage.getItem('i18nextLng')}/forgot-password`);
	}

	//register click handler
	const register = () => {
		let redirect_to = type && type != '' ? type : 'register'
		if (redirect_to == "property-details") {
			props.history.push(`/${localStorage.getItem('i18nextLng')}/register/${redirect_to}`);
		} else if (redirect_to == "tour-details") {
			props.history.push(`/${localStorage.getItem('i18nextLng')}/register/${redirect_to}`);
		} else {
			props.history.push(`/${localStorage.getItem('i18nextLng')}/register`);
		}
	}


	//login button click fn
	const handleKeyPress = (event) => {
		if (event.keyCode === 13)
			login();
	}

	//login post api
	const login = (e) => {
		let valid = validation();
		if (valid) {
			loaderStateTrue();
			let data = {}
			data["username"] = email
			data["userEnd"] = 'customerEnd'
			data["password"] = password
			LoginController.loginGetApi(data).then((response) => {
				loaderStateFalse();
				if (response) {
					if (response.success) {
						//new password set
						if (response.data.challengeName == "NEW_PASSWORD_REQUIRED") {
							setState(prev => ({
								...prev,
								modalShow: true,
								updatedPasswordSession: response.data.session,
								challangeName: response.data.challengeName,
								userName: response.data.username
							}))
						} else if (response.data.challengeName == 'SMS_MFA') {
							//sms_mfa
							let session = response.data.session;
							setToken('', '', '', '', session).then(() => {
								smsVerificationFn();
							});
						} else if (response.data.challengeName == "SOFTWARE_TOKEN_MFA") {
							//authentication app 
							setChallangeName("SOFTWARE_TOKEN_MFA")
							let session = response.data.session;
							setToken('', '', '', '', session).then(() => {
								smsVerificationFn();
							});
						} else {
							loginSuccess(response);
						}
					} else {
						if (response.message == "User does not exist.") {
							setState(prev => ({
								...prev,
								passwordError: `${props.t('wrongEmailPassword')}`
							}))

						} else if (response.message == "PreAuthentication failed with error Password has expired. Please re your password..") {
							props.history.push(`/${localStorage.getItem('i18nextLng')}/forget-password/${email}`);
						} else {
							setState(prev => ({
								...prev,
								passwordError: response.message,
								passtype: "password",
							}))
						}

					}
				}
			}).catch((error) => {
				loaderStateFalse();
				if (error.response.status === 400) {
					if (error?.response?.data?.message == "PreAuthentication failed with error Password has expired. Please re your password..") {
						props.history.push(`/${localStorage.getItem('i18nextLng')}/forgot-password/${email}`);
					} else if (error?.response?.data?.message == 'You have already registered but not confirmed your email. We have sent you a new confirmation code in your email.') {
						setSmsVerficationPopupStatus('user_unconfirmed')
						smsVerificationFn();
					}
				}
			});
		}

	}

	useEffect(() => {
		if (state.loginCredentials && Object.keys(state.loginCredentials).length > 0) {
			//when login credentials state changes set thevalue in redux
			setUserCredentialsData();
		}
	}, [state.loginCredentials]);

	const loginSuccess = (response) => {

		const finalIdToken = response.data.tokenType + ' ' + response.data.idToken;
		const accessToken = response.data.accessToken
		const refreshToken = response.data.refreshToken
		const expiresIn = LoginUtility.getExpiryDetails(response.data.expiresIn)
		setToken(finalIdToken, accessToken, expiresIn, refreshToken).then(() => {
			loaderStateTrue();
			LoginController.getCurrentUser().then((userResponse) => {
				if (userResponse.success) {
					Utility.toastNotificationsDismissAll();
					setState(prev => ({
						...prev,
						loginCredentials: userResponse.data
					}))
					setpassword("")
				} else {
					logOutApp().then(
						() => history.push("/")
					);
					Utility.toastNotifications(userResponse.message, "Error", "error")
				}
			})
		})
	}



	const setUserCredentialsData = async () => {
		const { loginCredentials } = state
		setUserCredentials(loginCredentials).then(async () => {
			let obj = {
				isLogin: true,
				allTabAction: "loginAllTab"
			}
			channel.postMessage(obj);
			if (loginCredentials.hasOwnProperty('user_details') && loginCredentials.user_details.role_name == "customer") {

				if (loginCredentials.user_details.is_first_time) {
					props.history.push(`/${localStorage.getItem('i18nextLng')}/change-password`);
				} else {
					// Use our flexible redirection system
					const language = localStorage.getItem('i18nextLng');
					// Check if we have saved redirect info
					const redirectInfo = await getRedirectInfo();
					// console.log("redirectInfo", redirectInfo);
					if (redirectInfo) {
						// Use the redirect URL from our utility
						const redirectUrl =await createRedirectUrl(language);
						// Clear the redirect info to prevent future redirects
						clearRedirectInfo();
						
						// Add a small delay to ensure auth state is fully updated in Redux
						setTimeout(() => {
							props.history.push(redirectUrl);
						}, 100);
					} else {
						// Fall back to original behavior if no saved redirect info
						let redirect_to = type != '' ? type : 'home';
						if (redirect_to == "property-details") {
							props.history.push(`/${language}/${redirect_to}`);
						} else if (redirect_to == "tour-details") {
							props.history.push(`/${language}/${redirect_to}`);
						} else if (redirect_to == "booking-history") {
							props.history.push(`/${language}/${redirect_to}`);
						} else if (redirect_to == "customerGroupexits") {
							props.history.push(`/${language}/tour-details`);
						} else if (redirect_to == "customerexits") {
							props.history.push(`/${language}/hotel-details`);
						} else {
							props.history.push(`/${language}/home`);
						}
					}
				}
				props.loaderStateFalse();
			} else {
				Utility.toastNotifications("Access denied", 'Error', 'error');
				logOutApp().then(
					() => history.push("/")
				);
			}


		})
	}





	const showText = () => {
		setState(prev => ({
			...prev,
			passwordLock: true,
			passtype: "text"
		}))
	}

	const showPassword = () => {
		setState(prev => ({
			...prev,
			passwordLock: false,
			passtype: "password"
		}))
	}

	const showUpdateConfirmText = () => {
		setState(prev => ({
			...prev,
			confirmPasswordLock: true,
			confirmPasstype: "text"
		}))
	}

	const showUpdateConfirmPassword = () => {
		setState(prev => ({
			...prev,
			confirmPasswordLock: false,
			confirmPasstype: "password"
		}))
	}

	const handleClose = () => {
		loaderStateFalse();
		setState(prev => ({
			...prev,
			modalShow: false,
			updated_password: "",
			updated_confirm_password: ""
		}))
	}

	// update password api fn
	const updatePassword = () => {
		const { updated_confirm_password, userName, updatedPasswordSession, challangeName } = state;
		// check validity
		let valid = updatePasswordCheck();
		if (valid) {
			loaderStateTrue();
			// update password dataset
			let header = {};
			header["session"] = updatedPasswordSession;
			let data = {
				"username": email,
				"password": updated_password,
				"challengeName": challangeName
			}
			LoginController.forcePasswordChange(data, header).then((response) => {
				if (response) {

					if (response.success) {
						handleClose();
						Utility.toastNotifications(response.message, "Success", "success")
						const finalIdToken = response.data.tokenType + ' ' + response.data.idToken;
						const accessToken = response.data.accessToken
						const refreshToken = response.data.refreshToken
						const expiresIn = LoginUtility.getExpiryDetails(response.data.expiresIn)
					} else {
						loaderStateFalse();
					}
				}
			}).catch((error) => {
				handleClose();
			});
		}
	}

	// update password validation fn
	const updatePasswordCheck = () => {
		let valid = true;
		if (updated_password == "") {
			valid = false;
			setState(prev => ({
				...prev,
				updated_passwordError: props.t('invalidField')
			}))
		}
		if (updated_confirm_password == "") {
			valid = false;
			setState(prev => ({
				...prev,
				updated_comfirm_passwordError: props.t('invalidField')
			}))
		}

		if (updated_password != "" && updated_confirm_password != "") {
			if (updated_password == updated_confirm_password && updated_password != "" && updated_confirm_password != "") {
				setState(prev => ({
					...prev,
					updated_passwordError: '',
					updated_comfirm_passwordError: ''
				}))
			} else {
				valid = false;
				Utility.toastNotifications(props.t('passwordAndConfirmPasswordNotMatch'), "Error", "error");
			}
		}
		return valid;

	}

	//language change fn
	const lanOnSelect = (lng) => {
		logger.log(lng);
		setState(prev => ({
			...prev,
			langaugeConfirmModal: true,
			selectedLangauge: lng
		}))
	}


	//language change confirmation modal confirm button click handler
	const confirmLangaugeChange = () => {
		const { selectedLangauge } = state;
		i18n.changeLanguage(selectedLangauge);
		let splitUrl = props.location.hash.split('/');
		props.history.push(`/${selectedLangauge}/${splitUrl[2]}`);
		window.location.reload();
		setState(prev => ({
			...prev,
			langaugeConfirmModal: false,
		}))

	}

	//language change confirmation modal cancel button click handler
	const cancelLangaugeChange = () => {
		setState(prev => ({
			...prev,
			langaugeConfirmModal: false,
		}))
	}

	//show password change fn
	const changeShowText = () => {
		setState(prev => ({
			...prev,
			changePasswordLock: true,
			changePasstype: "text"
		}))
	}

	//lock password change fn
	const changeShowPassword = () => {
		setState(prev => ({
			...prev,
			changePasswordLock: false,
			changePasstype: "password"
		}))
	}

	//show confirm password change fn
	const changeConShowText = () => {
		setState(prev => ({
			...prev,
			changeConpasswordLock: true,
			changeConpasstype: "text"
		}))
	}

	//lock confirm password change fn
	const changeConShowPassword = () => {
		setState(prev => ({
			...prev,
			changeConpasswordLock: false,
			changeConpasstype: "password"
		}))
	}

	// remember me fn
	const rememberMe = (e) => {
		if (e.target.checked == true) {
			setIsRemember(e.target.checked)
			Cookies.set('rememberMe', 'true', { expires: 30 });
			Cookies.set('email', email, { expires: 30 });
			Cookies.set('password', password, { expires: 30 });
		}
		if (e.target.checked == false) {
			setIsRemember(e.target.checked)
			Cookies.set('rememberMe', 'false', { expires: 0 });
			Cookies.set('email', "", { expires: 0 });
			Cookies.set('password', "", { expires: 0 });
		}
	}

	// mfa verification fn
	const smsVerificationFn = () => {
		setSmsVerificationModalContentFlag(true)
	}

	// mfa modal closing fn
	const closesmsVerificationFn = () => {
		setSmsVerificationModalContentFlag(false)
		setSmsVerficationPopupStatus("")
	}

	//submit otp fn in mfa modal 
	const handleSubmitOtpVerfication = (otp, mfaType) => {
		const { loaderStateTrue, loaderStateFalse } = props;
		// user is not confirmed his account 
		if (smsVerficationPopupStatus === 'user_unconfirmed') {
			let data = {
				"confirmation_code": otp.join(''),
				"email": email,
				"password": password
			}
			loaderStateTrue();
			LoginController.verifyOtp(data).then((response) => {
				if (response.success) {
					closesmsVerificationFn();
					Utility.toastNotifications(response.message, 'Success', 'success');
					if (type && type == "property-details") {
						props.history.push(`/${localStorage.getItem('i18nextLng')}/login/property-details`);
					} else if (type && type == "tour-details") {
						props.history.push(`/${localStorage.getItem('i18nextLng')}/login/tour-details`);
					} else {
						props.history.push(`/${localStorage.getItem('i18nextLng')}/login`);
					}
				} else {
					Utility.toastNotifications(response.message, 'Error', 'error');
				}
				loaderStateFalse();
			}).catch((error) => {
				loaderStateFalse();
			});
		} else {
			let data = {
				"otp": otp.join(''),
				"username": email,
				"challengeName": challangeName == "SOFTWARE_TOKEN_MFA" ? "SOFTWARE_TOKEN_MFA" : 'SMS_MFA'
			}
			loaderStateTrue();
			LoginController.verifyMfaOtp(data).then((response) => {
				if (response.success) {
					loginSuccess(response);
				} else {
				}
				loaderStateFalse();
			}).catch((error) => {
				loaderStateFalse();

			});
		}
	}

	// Phone OTP Login functions
	// Request OTP
	const requestOtp = async () => {
		// Validate phone number first
		if (!phone || !/^\d{10}$/.test(phone)) {
			setState(prev => ({
				...prev,
				phoneError: "Enter valid 10 digit phone number"
			}));
			return;
		}

		setState(prev => ({
			...prev,
			phoneError: ""
		}));

		loaderStateTrue();

		try {
			// Call the phone login API
			const response = await LoginController.phoneLogin(phone);
			// console.log(response)
			if (response?.success === true && response?.data?.session) {
				// console.log("OTP requested successfull....")
				setToken('', '', '', '', response.data.session);
				setOtpSent(true);
				setSessionToken(response.data.session);
				setOtp("");
			} else {
				setState(prev => ({
					...prev,
					phoneError: response?.data?.message || "Failed to send OTP. Please try again."
				}));
			}
		} catch (error) {
			if (error?.response?.data?.message == "Your account is not confirmed yet") {
				setSelectedActiveTab('email')
				Utility.toastNotifications(`To log in, please check your email for the temporary password and use it to log in via the "Password Login" option. Once logged in, you can complete your account confirmation. OTP login will only be available after email verification.`, 'Warning', 'warning');
			} else {

			}
			setState(prev => ({
				...prev,
				phoneError: error?.response?.data?.message || "Failed to send OTP. Please try again."
			}));
		} finally {
			loaderStateFalse();
		}
	};

	// Verify OTP
	const verifyOtp = async () => {
		// Validate OTP first
		if (!otp || !/^\d{6}$/.test(otp)) {
			setState(prev => ({
				...prev,
				otpError: "Enter valid 6 digit OTP"
			}));
			return;
		}

		setState(prev => ({
			...prev,
			otpError: ""
		}));

		loaderStateTrue();

		try {
			// Call the verify OTP API
			const response = await LoginController.otpVerify({
				username: phone,
				otp: otp
			});
			// console.log(response)
			if (response?.success === true && response?.data?.idToken) {
				// Login successful - handle the same way as password login success
				LoginController.setAccessToken(response.data.idToken);
				setToken(response.data.idToken);
				// setUserEntryType("userLogin");
				loginSuccess(response);
			} else {
				setState(prev => ({
					...prev,
					otpError: response?.data?.message || "Invalid OTP. Please try again."
				}));
			}
		} catch (error) {
			// console.error("OTP verification error:", error);
			if (error.response.data.message == "You have entered wrong OTP. Please try again") {
				setToken('', '', '', '', error.response.data.data.Session);
				setSessionToken(error.response.data.data.Session);
			}
			if (error.response.data.message == "You have entered 3 times incorrect OTP") {
				setOtpSent(false)
				setPhone("")
			}
			// setState(prev => ({
			// 	...prev,
			// 	otpError: error?.response?.data?.message || "OTP verification failed. Please try again."
			// }));
		} finally {
			loaderStateFalse();
		}
	};

	const clearErrors = () => {
		setState(prev => ({
			...prev,
			phoneError: "",
			otpError: ""
		}));
	};

	return (
		<div className="appContainer" id="login_container">
			<CommonLogin
				handleChange={handleChange}
				email={email}
				password={password}
				emailError={state.emailError}
				passwordError={state.passwordError}
				passtype={state.passtype}
				passwordLock={state.passwordLock}
				showText={showText}
				showPassword={showPassword}
				login={login}
				forgotPassword={forgotPassword}
				smsVerificationFn={smsVerificationFn}
				register={register}
				handleonFocus={handleonFocus}
				handleonBlur={handleonBlur}
				emailFocus={state.emailFocus}
				passwordFocus={state.passwordFocus}

				passPlaceholder={props.t('passPlaceholder')}
				forgotTitle={props.t('forgot_password_text')}
				submitTitle={props.t('loginButton')}
				user_name={props.t('user_name')}
				lanOnSelect={lanOnSelect}
				handleKeyPress={handleKeyPress}
				rememberMe={rememberMe}
				isRemember={isRemember}

				/* Phone OTP props */
				phone={phone}
				otp={otp}
				otpSent={otpSent}
				phoneError={state.phoneError}
				otpError={state.otpError}
				requestOtp={requestOtp}
				verifyOtp={verifyOtp}
				selectedActiveTab={selectedActiveTab}
				sessionToken={sessionToken}
				setSessionToken={setSessionToken}
				setOtpSent={setOtpSent}
				setemail={setemail}
				setpassword={setpassword}
				setPhone={setPhone}
				setIsRemember={setIsRemember}
				clearErrors={clearErrors}
			/>

			<Modal
				show={state.modalShow}
				onHide={handleClose}
				className="forcePasswordChange changePasswordModalContent"
			>
				<Modal.Header closeButton>
					<Modal.Title>{props.t('ChangePasswordButton')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className='password-rules-box'>
						<div className='pass-left-box'>
							<div className="passwordRow relativeRow">
								<input type={state.changePasstype == "text" ? "text" : "password"} onChange={handleChange} name="updated_password" value={updated_password} placeholder={props.t('updatepassword')} className="input__fields_property" />
								{!state.changePasswordLock ?
									<span className="passwordEyeIcon" onClick={changeShowText}>
										<i className="fa fa-eye-slash" aria-hidden="true"></i>
									</span>

									:
									<span className="passwordEyeIcon" onClick={changeShowPassword}>
										<i className="fa fa-eye" aria-hidden="true"></i>
									</span>

								}
								<div className="col-md-12 errorClass error_div">{state.updated_passwordError}</div>
							</div>
							<div className="passwordRow relativeRow">
								<input type={state.changeConpasstype == "text" ? "text" : "password"} onChange={handleChange} name="updated_confirm_password" value={updated_confirm_password} placeholder={props.t('updateconfirmpass')} className="input__fields_property" />
								{!state.changeConpasswordLock ?
									<span className="passwordEyeIcon" onClick={changeConShowText}>
										<i className="fa fa-eye-slash" aria-hidden="true"></i>
									</span>

									:
									<span className="passwordEyeIcon" onClick={changeConShowPassword}>
										<i className="fa fa-eye" aria-hidden="true"></i>
									</span>

								}
								<div className="col-md-12 errorClass error_div">{state.updated_comfirm_passwordError}</div>
							</div>
						</div>
						<div className='pass-divider'></div>
						<div className='pass-right-box'>
							<h5>Password Hints:</h5>
							<ul className='password-inner-box'>
								<li><span>Minimum length</span>, which must be at least 8 characters</li>
								<li><span>Contains at least 1 number</span></li>
								<li><span>Contains at least 1 special character</span> {"from this set: ^ $ * . [ ] { } ( ) ? - ! @ # % & / \\ , > < ' : ; | _ ~ ` + = "} <br /><span>The non-leading, non-trailing space character is also treated as a special character.</span></li>
								<li><span>Contains at least 1 uppercase letter</span></li>
								<li><span>Contains at least 1 lowercase letter</span></li>
							</ul>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="primary" onClick={updatePassword} className="update_btn">{props.t('submit')}</Button>
				</Modal.Footer>
			</Modal>

			<ModalGlobal
				show={state.langaugeConfirmModal}
				onHide={cancelLangaugeChange}
				className="modalcustomize confirmationalertmodal"
				bodyClassName="cancelConfirmationbody"
				headerclassName="close_btn_icon"
				title={props.t('languagechange')}
				footer={false}
				body={
					<ConfirmationAlert
						BodyFirstContent={props.t('areYouSureYouWantToReload')}
						confirmationButtonContent={props.t('confirm')}
						deleteConfirmButton={confirmLangaugeChange}
						cancelButtonContent={props.t('cancel')}
						deleteCancleButton={cancelLangaugeChange}
					/>
				}
			/>

			<ModalGlobal
				show={state.langaugeConfirmModal}
				onHide={cancelLangaugeChange}
				className="modalcustomize confirmationalertmodal"
				bodyClassName="cancelConfirmationbody"
				headerclassName="close_btn_icon"
				title={props.t('languagechange')}
				footer={false}
				body={
					<ConfirmationAlert
						BodyFirstContent={props.t('areYouSureYouWantToReload')}
						confirmationButtonContent={props.t('confirm')}
						deleteConfirmButton={confirmLangaugeChange}
						cancelButtonContent={props.t('cancel')}
						deleteCancleButton={cancelLangaugeChange}
					/>
				}
			/>



			<ModalGlobal
				show={smsVerificationModalContentFlag}
				onHide={closesmsVerificationFn}
				title=""
				className="modalcustomize mondimension smsVerificationModalContent"
				footer={false}
				closeButton={true}
				saveButtonLabel="Confirm"
				saveButtonClassName="btn btn-primary savebtn"
				cancelShow={true}
				body={
					<>

						<SmsVerification
							formData={{ 'email': email }}
							callFrom={smsVerficationPopupStatus == 'user_unconfirmed' ? 'email' : challangeName == "SOFTWARE_TOKEN_MFA" ? "SOFTWARE_TOKEN_MFA" : 'SMS_MFA'}
							handleSubmitOtpVerfication={handleSubmitOtpVerfication}
						/>

					</>
				}
			/>


		</div>
	);
}

CommonLogin.propTypes = {
	handleChange: PropTypes.func,
	email: PropTypes.string,
	password: PropTypes.string,
	emailError: PropTypes.string,
	passwordError: PropTypes.string,
	passtype: PropTypes.string,
	passwordLock: PropTypes.bool,
	showText: PropTypes.func,
	showPassword: PropTypes.func,
	login: PropTypes.func,
	forgotPassword: PropTypes.func,
	backgroundImageUrl: PropTypes.string
}


const mapStateToProps = (globalState) => {
	return {
		userCredentials: globalState.LoginReducer.userCredentials,
		token: globalState.LoginReducer.token,
		priceDistributionRequestData: globalState.mainReducerData.priceDistributionRequestData,
		priceDistributionResponseData: globalState.mainReducerData.priceDistributionResponseData
	};
}

export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setToken, setUserCredentials, logOutApp, roleWisePermission, setVersionList })(withNamespaces()(LoginPage));


